<template>
  <div>
    <apexchart
      :key="chartKey"
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    apexchart: VueApexCharts
  },
  props: ['value'],
  data() {
    return {
      chartKey: 0,
      data: null,
      series: [],

      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#000']
          }
        },
        xaxis: {
          type: 'datetime',
          categories: []
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val} รายการ`
            }
          }
        }
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.data = this.value
      },
      deep: true
    }
  },
  mounted() {
    if (this.value) {
      this.data = this.value
      this.handleInitChart()
    }
  },
  methods: {
    handleInitChart() {
      const vm = this
      try {
        const tempData = cloneDeep(vm.data.order_stat_graph)
        if (tempData) {
          vm.chartOptions.xaxis.categories = Object.keys(tempData)
          const seriesData = Object.values(tempData)
          vm.series.push({ name: 'ออเดอร์', data: seriesData })
          vm.chartKey += 1
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/OrderStatistics/OrderStatisticsChart.vue